import LocomotiveScroll from 'locomotive-scroll';

(() => {
  document.documentElement.classList.add('is-loaded');
  document.documentElement.classList.remove('is-loading');

  setTimeout(() => {
    document.documentElement.classList.add('is-ready');
  }, 300);

  const options = {
    el: document.querySelector('#js-scroll'),
    smooth: false,
  };

  // If there is a form matching the hash init locomotive there
  if (window.location.hash === '#get') {
    const form = document.querySelector(`#get`);
    if (form) {
      options.initPosition = { x: 0, y: form.offsetTop };
    }
  }

  setTimeout(() => {
    // eslint-disable-next-line no-unused-vars
    const scroll = new LocomotiveScroll(options);
  }, 1000);
})();



// WEBPACK FOOTER //
// ./src/scripts/modules/scroll.js